import React from 'react';
import { observer } from 'mobx-react-lite';

export const SettingsPage: React.FC = observer(() => {
  return (
    <div className="h-full overflow-y-auto">
      <div className="p-4">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">Settings</h1>

        {/* Account Section */}
        <div className="bg-white rounded-xl p-4 mb-4">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Account</h2>
          <div className="space-y-3">
            <button className="w-full flex items-center justify-between py-3 border-b border-gray-100">
              <span className="text-gray-700">Profile</span>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M9 18l6-6-6-6" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <button className="w-full flex items-center justify-between py-3 border-b border-gray-100">
              <span className="text-gray-700">Preferences</span>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M9 18l6-6-6-6" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <button className="w-full flex items-center justify-between py-3">
              <span className="text-gray-700">Notifications</span>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M9 18l6-6-6-6" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
        </div>

        {/* Restaurant Settings */}
        <div className="bg-white rounded-xl p-4 mb-4">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Restaurant</h2>
          <div className="space-y-3">
            <button className="w-full flex items-center justify-between py-3 border-b border-gray-100">
              <span className="text-gray-700">Business Hours</span>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M9 18l6-6-6-6" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <button className="w-full flex items-center justify-between py-3 border-b border-gray-100">
              <span className="text-gray-700">Menu Management</span>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M9 18l6-6-6-6" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <button className="w-full flex items-center justify-between py-3">
              <span className="text-gray-700">Delivery Settings</span>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M9 18l6-6-6-6" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
        </div>

        {/* App Settings */}
        <div className="bg-white rounded-xl p-4 mb-4">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">App</h2>
          <div className="space-y-3">
            <button className="w-full flex items-center justify-between py-3 border-b border-gray-100">
              <span className="text-gray-700">Language</span>
              <div className="flex items-center gap-2">
                <span className="text-sm text-gray-500">English</span>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M9 18l6-6-6-6" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </button>
            <button className="w-full flex items-center justify-between py-3 border-b border-gray-100">
              <span className="text-gray-700">Theme</span>
              <div className="flex items-center gap-2">
                <span className="text-sm text-gray-500">Light</span>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M9 18l6-6-6-6" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </button>
            <button className="w-full flex items-center justify-between py-3">
              <span className="text-gray-700">About</span>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M9 18l6-6-6-6" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
        </div>

        {/* Logout Button */}
        <button className="w-full bg-red-50 text-red-600 font-semibold py-3 rounded-xl hover:bg-red-100 transition-colors">
          Logout
        </button>
      </div>
    </div>
  );
});
